import styled from 'styled-components'

export const Title = styled.div`
  color: #757575;
  font-size: 14px;
  font-weight: 700;
  padding: 16px 0 4px;
  svg {
    margin-left: 5px;
    width: 12px;
  }
`

export const Counter = styled.div`
  color: #213f68;
  font-size: 12px;
  margin-top: 4px;
  svg {
    margin-right: 4px;
  }
`
